import React, { useState } from "react";
import { Modal } from 'react-bootstrap';
import { Row, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import btnClose from "../../../assets/images/svg/close_modal_icon.svg";
import constants from "../../../constants/constants";

function CancelFreePackageModal(props) {
    return (
        <>
            <Modal size="sm" show={props.showCancelFreePackageModal} onHide={props.handleCloseCancelFreePackage} className="service-modal-content rtl">
                <Modal.Header>
                    <Modal.Title>
                        {constants.ConfirmServiceCancellation}
                        <img
                            onClick={props.handleCloseCancelFreePackage}
                            src={btnClose}
                            className="btn-close"
                            size="sm"
                            alt=""
                        />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <span>{props.info}</span>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="confirm-button" variant="primary" onClick={(e) => props.handleCancelFreePackage(e)}>
                        {constants.CancelPackage}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default CancelFreePackageModal;